import * as React from 'react'

interface HeadingProps {
	title:string
}

export const SectionHeading = (props:HeadingProps) => <h3 className="sbSectionHeading">{props.title}</h3>


// WEBPACK FOOTER //
// ./src/lib/sbhtml/heading.tsx